import { render, staticRenderFns } from "./ItemBankTransfer.vue?vue&type=template&id=3fbcc283&scoped=true&"
import script from "./ItemBankTransfer.vue?vue&type=script&lang=js&"
export * from "./ItemBankTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ItemBankTransfer.vue?vue&type=style&index=0&id=3fbcc283&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbcc283",
  null
  
)

export default component.exports